import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface FullScreenLoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ 
  message = 'Loading...', 
  size = 'lg',
  color = 'rgb(37 99 235)' // default blue color
}) => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 z-50 flex flex-col items-center justify-center">
      <LoadingSpinner size={size} color={color} />
      <p className="mt-4 text-gray-700 font-medium text-lg">{message}</p>
    </div>
  );
};

export default FullScreenLoader;
